// Complete Pokemon Champions ability database
// Source: game8.co/serebii Pokemon Champions ability list

const ABILITIES = {
  'Adaptability': 'STAB bonus increased from 1.5x to 2x.',
  'Aerilate': 'Normal moves become Flying-type with 20% boost.',
  'Aftermath': 'Damages attacker by 1/4 HP when KOd.',
  'Analytic': '30% power boost when moving last.',
  'Anger Point': 'Maximizes Attack on critical hit.',
  'Anticipation': 'Senses super-effective or OHKO moves.',
  'Armor Tail': 'Blocks opponent priority moves (Fake Out, etc).',
  'Aroma Veil': 'Prevents Taunt, Encore, Disable on team.',
  'Berserk': '+1 SpA when HP drops below 50%.',
  'Big Pecks': 'Prevents Defense reduction.',
  'Blaze': '+50% Fire power below 1/3 HP.',
  'Bulletproof': 'Immune to ball/bomb moves (Shadow Ball, Aura Sphere, etc).',
  'Cheek Pouch': 'Restores 1/3 HP when eating a berry.',
  'Chlorophyll': 'Doubles Speed in Sun.',
  'Clear Body': 'Prevents stat reduction from opponents.',
  'Cloud Nine': 'Negates all weather effects.',
  'Competitive': '+2 SpA when any stat is lowered. Counters Intimidate.',
  'Compound Eyes': '+30% accuracy on moves.',
  'Contrary': 'Reverses all stat changes.',
  'Corrosion': 'Can poison Steel and Poison types.',
  'Cud Chew': 'Reuses consumed berry next turn.',
  'Curious Medicine': 'Resets ally stat changes on entry.',
  'Cursed Body': '30% chance to Disable attacker move.',
  'Cute Charm': '30% infatuation on contact.',
  'Damp': 'Prevents Explosion and Self-Destruct.',
  'Defiant': '+2 Attack when any stat is lowered. Counters Intimidate.',
  'Disguise': 'Blocks one hit, then breaks (Mimikyu).',
  'Dragonize': 'Normal moves become Dragon-type with 20% boost.',
  'Drizzle': 'Sets Rain for 5 turns on entry.',
  'Drought': 'Sets Sun for 5 turns on entry.',
  'Dry Skin': 'Water heals 1/4 HP; Fire does 25% more; rain heals, sun hurts.',
  'Early Bird': 'Wakes from sleep twice as fast.',
  'Earth Eater': 'Ground moves restore 1/4 HP.',
  'Electromorphosis': 'Boosts next Electric move after taking damage.',
  'Fairy Aura': '+33% Fairy power for all Pokemon.',
  'Filter': 'Reduces super-effective damage by 25%.',
  'Flame Body': '30% burn on contact.',
  'Flash Fire': 'Absorbs Fire moves, boosts own Fire by 50%.',
  'Flower Veil': 'Grass allies immune to status and stat drops.',
  'Forecast': 'Changes type with weather (Castform).',
  'Friend Guard': 'Reduces ally damage by 25%.',
  'Frisk': 'Reveals opponent held items.',
  'Fur Coat': 'Halves physical damage.',
  'Gale Wings': 'Flying moves get priority at full HP.',
  'Gluttony': 'Eats berry at 50% HP instead of 25%.',
  'Gooey': '-1 Speed to attacker on contact.',
  'Guts': '+50% Attack with status; ignores burn penalty.',
  'Harvest': '50% chance to regrow berry each turn (100% in Sun).',
  'Healer': '50% chance to cure ally status each turn.',
  'Heatproof': 'Halves Fire and burn damage.',
  'Heavy Metal': 'Doubles weight.',
  'Hospitality': 'Heals partner by 25% HP on entry.',
  'Huge Power': 'Doubles Attack stat.',
  'Hustle': '+50% Attack, -20% accuracy.',
  'Hydration': 'Cures status in Rain.',
  'Hyper Cutter': 'Prevents Attack reduction.',
  'Ice Body': 'Restores 1/16 HP in Snow.',
  'Illuminate': 'Ignores evasion; prevents accuracy drops.',
  'Illusion': 'Appears as last party member until hit.',
  'Immunity': 'Prevents poison.',
  'Imposter': 'Transforms into opponent on entry (Ditto).',
  'Infiltrator': 'Bypasses screens, Substitute, Safeguard.',
  'Innards Out': 'Deals damage equal to HP lost when KOd.',
  'Inner Focus': 'Prevents flinching; ignores Intimidate.',
  'Insomnia': 'Cannot be put to sleep.',
  'Intimidate': '-1 Attack to all opponents on entry.',
  'Iron Fist': '+20% power to punching moves.',
  'Justified': '+1 Attack when hit by Dark moves.',
  'Keen Eye': 'Ignores evasion; prevents accuracy drops.',
  'Klutz': 'Cannot use held items.',
  'Leaf Guard': 'Prevents status in Sun.',
  'Levitate': 'Immune to Ground moves.',
  'Light Metal': 'Halves weight.',
  'Lightning Rod': 'Redirects Electric moves; +1 SpA.',
  'Limber': 'Prevents paralysis.',
  'Liquid Voice': 'Sound moves become Water-type.',
  'Long Reach': 'Moves never make contact.',
  'Magic Bounce': 'Reflects status moves back at user.',
  'Magic Guard': 'Only takes damage from direct attacks.',
  'Magician': 'Steals opponent item on hit.',
  'Magma Armor': 'Prevents freezing.',
  'Marvel Scale': '+50% Defense with status condition.',
  'Mega Launcher': '+50% power to pulse/aura moves.',
  'Mega Sol': 'Always acts as if Sun is active.',
  'Merciless': 'Always crits poisoned targets.',
  'Mimicry': 'Type changes with active terrain.',
  'Minus': '+50% SpA if ally has Plus/Minus.',
  'Mirror Armor': 'Reflects stat drops back at opponent.',
  'Mold Breaker': 'Ignores opponent abilities.',
  'Moody': '+2 random stat, -1 random stat each turn.',
  'Motor Drive': 'Electric moves boost Speed +1.',
  'Moxie': '+1 Attack on KO.',
  'Multiscale': 'Takes 50% damage at full HP.',
  'Mummy': 'Changes attacker ability to Mummy on contact.',
  'Natural Cure': 'Cures status on switch-out.',
  'No Guard': 'All moves by/against this Pokemon always hit.',
  'Oblivious': 'Prevents infatuation and Taunt; ignores Intimidate.',
  'Opportunist': 'Copies opponent stat boosts.',
  'Overcoat': 'Immune to powder moves and weather damage.',
  'Overgrow': '+50% Grass power below 1/3 HP.',
  'Own Tempo': 'Prevents confusion; ignores Intimidate.',
  'Parental Bond': 'Attacks twice; second hit at 1/4 power.',
  'Pickpocket': 'Steals attacker item on contact.',
  'Piercing Drill': 'Contact moves hit through Protect at 1/4 damage.',
  'Pixilate': 'Normal moves become Fairy-type with 20% boost.',
  'Plus': '+50% SpA if ally has Plus/Minus.',
  'Poison Heal': 'Heals 1/8 HP per turn while poisoned.',
  'Poison Point': '30% poison on contact.',
  'Poison Touch': '30% poison on contact moves.',
  'Prankster': '+1 priority on status moves (blocked by Dark types).',
  'Pressure': 'Opponent moves cost 2 PP.',
  'Protean': 'Changes type to match move used (once per entry).',
  'Pure Power': 'Doubles Attack stat.',
  'Purifying Salt': 'Halves Ghost damage; prevents status.',
  'Queenly Majesty': 'Blocks opponent priority moves.',
  'Quick Draw': '30% chance to move first.',
  'Quick Feet': '+50% Speed with status; ignores paralysis penalty.',
  'Rain Dish': 'Restores 1/16 HP in Rain.',
  'Reckless': '+20% power to recoil moves.',
  'Refrigerate': 'Normal moves become Ice-type with 20% boost.',
  'Regenerator': 'Heals 33% HP on switch-out.',
  'Ripen': 'Doubles berry effects.',
  'Rock Head': 'Prevents recoil damage.',
  'Rough Skin': 'Deals 1/8 HP to attacker on contact.',
  'Sand Force': '+30% Rock/Ground/Steel in Sandstorm.',
  'Sand Rush': 'Doubles Speed in Sandstorm.',
  'Sand Stream': 'Sets Sandstorm for 5 turns on entry.',
  'Sand Veil': '+25% evasion in Sandstorm.',
  'Sap Sipper': 'Grass moves boost Attack +1.',
  'Scrappy': 'Normal/Fighting hit Ghost; ignores Intimidate.',
  'Screen Cleaner': 'Removes screens on entry.',
  'Shadow Tag': 'Prevents opponent switching.',
  'Sharpness': '+50% power to slicing moves.',
  'Shed Skin': '30% cure status each turn.',
  'Sheer Force': '+30% power but removes secondary effects.',
  'Shell Armor': 'Prevents critical hits.',
  'Shield Dust': 'Prevents secondary effects from attacks.',
  'Skill Link': 'Multi-hit moves always hit max times.',
  'Slush Rush': 'Doubles Speed in Snow.',
  'Sniper': 'Critical hits deal 2.25x instead of 1.5x.',
  'Snow Cloak': '+25% evasion in Snow.',
  'Snow Warning': 'Sets Snow on entry.',
  'Solar Power': '+50% SpA in Sun; loses 1/8 HP per turn.',
  'Solid Rock': 'Reduces super-effective damage by 25%.',
  'Soundproof': 'Immune to sound moves.',
  'Speed Boost': '+1 Speed each turn.',
  'Spicy Spray': 'Burns attacker when this Pokemon takes damage.',
  'Stall': 'Always moves last.',
  'Stalwart': 'Ignores Follow Me and redirection.',
  'Stamina': '+1 Defense when hit.',
  'Stance Change': 'Switches between Blade/Shield forms (Aegislash).',
  'Static': '30% paralyze on contact.',
  'Steadfast': '+1 Speed when flinched.',
  'Sticky Hold': 'Prevents item theft/removal.',
  'Strong Jaw': '+50% power to biting moves.',
  'Sturdy': 'Survives OHKO with 1 HP at full health.',
  'Super Luck': '+1 crit rate.',
  'Supersweet Syrup': '-1 evasion to opponents on entry.',
  'Supreme Overlord': '+10% power per fainted teammate (max +50%).',
  'Surge Surfer': 'Doubles Speed on Electric Terrain.',
  'Swarm': '+50% Bug power below 1/3 HP.',
  'Sweet Veil': 'Prevents sleep for user and allies.',
  'Swift Swim': 'Doubles Speed in Rain.',
  'Synchronize': 'Reflects burn/paralysis/poison to attacker.',
  'Technician': '+50% power to moves with 60 BP or less.',
  'Telepathy': 'Avoids ally attacks in doubles.',
  'Thick Fat': 'Halves Fire and Ice damage.',
  'Torrent': '+50% Water power below 1/3 HP.',
  'Tough Claws': '+30% power to contact moves.',
  'Toxic Debris': 'Sets Toxic Spikes when hit physically.',
  'Trace': 'Copies opponent ability on entry.',
  'Unaware': 'Ignores opponent stat changes.',
  'Unburden': 'Doubles Speed when item consumed/lost.',
  'Unnerve': 'Prevents opponents from eating berries.',
  'Unseen Fist': 'Contact moves bypass Protect.',
  'Vital Spirit': 'Cannot be put to sleep.',
  'Volt Absorb': 'Electric moves restore 1/4 HP.',
  'Wandering Spirit': 'Swaps abilities with attacker on contact.',
  'Water Absorb': 'Water moves restore 1/4 HP.',
  'Water Bubble': 'Halves Fire damage; doubles Water power; prevents burns.',
  'Weak Armor': '-1 Def, +2 Speed when hit physically.',
  'White Smoke': 'Prevents stat reduction.',
  'Zero To Hero': 'Changes to Hero Form on switch-out (Palafin).',
};

export const ALL_ABILITIES = Object.keys(ABILITIES).sort();
export default ABILITIES;
